import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import TkVisualizer from '@/../bower_components/teknisavuecomponents/components/document/TkVisualizer/TkVisualizer.vue';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import DocumentosController from '@/assets/ts/controller/DocumentosController';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import { SolicitacaoController } from '@/assets/ts/controller/SolicitacaoController';
import OfflineController from '@/assets/ts/controller/OfflineController';
import CordovaController from '@/assets/ts/controller/CordovaController';

@Component({
  name: 'DocumentosSolicitacao',
  components: {
    EditableTable,
    TkVisualizer,
  }
})
class DocumentosSolicitacao extends Vue {
  // #region [ PROPS ]
  @Prop({ default: '' })
  private readonly nrSolicitacao: string;

  @Prop({ default: '' })
  private readonly nrVinculo: string;

  @Prop({ default: '' })
  private readonly title: string;

  @Prop({ default: 0 })
  private readonly triggerReload: number;

  @Prop({ default: false })
  private readonly value: boolean;
  // #endregion

  // #region [ EVENTS ]
  @Emit('input')
  private emitInput(value: boolean) {}

  @Emit('add')
  private emitAdd() {}
  // #endregion

  //#region [ DATA ]
  private internalValue = false;

  private columns = [
    {
      value: 'NMFILE',
      text: 'Nome',
      type: 'text',
    },
    {
      value: 'IDTYPE',
      text: 'Tipo',
      type: 'text',
    },
    {
      value: 'NMOPERADOR',
      text: 'Operador Inclusão',
      type: 'text',
    },
    {
      value: 'DTINCLUSAO',
      text: 'Data de Inclusão',
      type: 'date',
    },
  ];

  private documentos = [];

  private loading = false;

  private actions = [
    {
      name: 'view',
      label: 'Visualizar',
      icon: 'mdi-eye',
      onClick: this.view,
      mode: 'view',
    },
    {
      name: 'download',
      label: 'Baixar',
      icon: 'mdi-download',
      onClick: this.download,
      mode: 'view',
    },
  ];

  private toolbarActions = [
    {
      name: 'reload',
      label: 'Atualizar',
      icon: 'mdi-refresh',
      onClick: this.reloadDocumentos,
    },
  ];

  private visualizer = {
    show: false,
    base64: '',
    mimeType: '',
    fileName: '',
  };
  //#endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      this.reloadDocumentos();
    }
  }

  @Watch('triggerReload')
  private trigeerReloadOnChange() {
    this.reloadDocumentos();
  }
  // #endregion

  // #region [ METHODS ]
  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  private async reloadDocumentos() {
    this.loading = true;
    this.documentos = [];

    try {
    
      const documentos = await SolicitacaoController.getSolicitacaoFile(this.nrSolicitacao);

      documentos.forEach((doc) => {
        doc.DTINCLUSAO = doc.DTINCLUSAO.replace(' 00:00:00', '');
      });

      this.documentos = documentos;
    } finally {
      this.loading = false;
    }
  }

  private async view(
    documento
  ) {
    this.loading = true;

    try {

      const { base64, type } = documento;

      const fullBase64 = FileUtils.getFullBase64(
        base64, type
      );

      const fileName = `solicitacao${this.nrVinculo}_${this.nrSolicitacao}`;
      
      this.visualizer.show = true;
      this.visualizer.base64 = fullBase64;
      this.visualizer.mimeType = type;
      this.visualizer.fileName = fileName;

    } catch {
      const message = 'Não foi possível carregar o arquivo!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    } finally {
      this.loading = false;
    }
  }

  private async download(
    documento
  ) {

    if(OfflineController.isMobile()) {
      try {
        await CordovaController.checkStorageAccessMobile();
      } catch (error) {
        const message = 'Permissões de armazenamento são necessárias para baixar o relatório. Por favor, revise as permissões e tente novamente.';
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
        return;
      }
    }
  
    this.loading = true;

    try {
      const { type, base64, NMFILE } = documento;

      const fileName = `solicitacao${this.nrVinculo}_${this.nrSolicitacao}${NMFILE ? `_${NMFILE}` : ''}`;

      FileUtils.downloadBase64File(
        fileName, base64, type
      );

      setTimeout(() => {
        this.loading = false;
      }, 2000);
    } catch (err) {
      const message = 'Não foi possível fazer o download do arquivo!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      this.loading = false;
      throw err;
    }
  }

  // #endregion
}

export default DocumentosSolicitacao;